export const STATUS_CONFIG = {
  pending: { label: 'Pending', color: 'bg-slate-100 text-slate-700', barColor: '#94a3b8' },
  in_progress: { label: 'In Progress', color: 'bg-blue-100 text-blue-700', barColor: '#3b82f6' },
  pending_approval: { label: 'Pending Approval', color: 'bg-purple-100 text-purple-700', barColor: '#a855f7' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-700', barColor: '#22c55e' }
};
